let initialized = false;
const SOUNDS = new Map([
    ['answered', {audio: new Audio(`/${process.env.PUBLIC_URL}ivr_audio/answered.mp3`), volume: 1.0}],
    ['rejected', {audio: new Audio(`/${process.env.PUBLIC_URL}ivr_audio/rejected.mp3`), volume: 0.5}],
    ['ringback', {audio: new Audio(`/${process.env.PUBLIC_URL}ivr_audio/ringback.mp3`), volume: 0.5}]
]);



	/**
	 * Play all the sounds so they will play in mobile browsers at any time
	 */
export const initialize = () => {
    if (initialized)
        return;

    for ( const sound of SOUNDS.values() ) {
        console.log("sound", sound);
        sound.audio.volume = 0;
        sound.audio.loop = true;

        try {
            sound.audio.play();
        } catch (error) {

        }
    }

    initialized = true;
};

/**
 * Play a sound
 * @param {String} name - Sound name
 * @param {[Float]} relativeVolume - Relative volume (0.0 - 1.0)
 */
export const play = (name, relativeVolume) => {
    initialize();

    if (typeof relativeVolume !== 'number') {
        relativeVolume = 1.0;
    }

    const sound = SOUNDS.get(name);

    if (!sound) {
        throw new Error(`unknown sound name "${name}"`);
    }

    try {
        sound.audio.pause();
        sound.audio.currentTime = 0.0;
        sound.audio.volume = (sound.volume || 1.0) * relativeVolume;
        sound.audio.play();
    } catch (error) {
        console.log('play() | error: ', error);
    }
};

export const stop = (name) => {
    const sound = SOUNDS.get(name);

    if (!sound) {
        throw new Error(`unknown sound name "${name}"`);
    }

    sound.audio.pause();
    sound.audio.currentTime = 0.0;
};